/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable arrow-body-style */
/* eslint-disable no-nested-ternary */
import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { tableStatusColor } from 'src/utils/getColorByStatus';
import { tableMasks } from 'src/utils/tableMasks';
import moment from 'moment';

// ----------------------------------------------------------------------

export type UseTableProps = {
  dense: boolean;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  rowsPerPage: number;
  order: 'asc' | 'desc';
  orderBy: string;
  //
  selected: string[];
  setSelected: React.Dispatch<React.SetStateAction<string[]>>;
  onSelectRow: (id: string) => void;
  onSelectAllRows: (checked: boolean, newSelecteds: string[]) => void;
  //
  onSort: (id: string) => void;
  onChangePage: (event: unknown, newPage: number) => void;
  onChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeDense: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export type Props = {
  tableData: any;
  header: {
    id: string;
    subId?: string;
    label: string;
    align?: string;
    type?: string;
    mask?: string;
  }[];
  defaultDense?: boolean;
  defaultOrder?: 'asc' | 'desc';
  defaultOrderBy?: string;
  defaultSelected?: string[];
  defaultRowsPerPage?: number;
  defaultCurrentPage?: number;
  defaultSelectedOption?: string;
  onSelectRowFunction?: (id: string) => void;
  onSelectAllRowFunction?: (id: string[]) => void;
  startDate?: Date;
  endDate?: Date;
  setStartDate?: (date: Date) => void;
  setEndDate?: (date: Date) => void;
};

export default function useTableRox({
  tableData,
  header,
  defaultDense,
  defaultOrder,
  defaultOrderBy,
  defaultSelected,
  defaultSelectedOption,
  defaultRowsPerPage,
  defaultCurrentPage,
  onSelectRowFunction,
  onSelectAllRowFunction,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}: Props) {
  const [orderBy, setOrderBy] = useState(defaultOrderBy || 'name');

  const [order, setOrder] = useState<'asc' | 'desc'>(defaultOrder || 'asc');

  const [page, setPage] = useState(defaultCurrentPage || 0);

  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage || 5);

  const [selected, setSelected] = useState<string[]>(defaultSelected || []);

  const [selectedOption, setSelectedOption] = useState<any>(defaultSelectedOption || []);

  const [filterName, setFilterName] = useState('');

  const [filteredData, setFilteredData] = useState(tableData || []);

  const [loadingSearch, setLoadingSearch] = useState(false);
  const [startDateSearch, setStartDateSearch] = useState<any>(moment().startOf('month'));
  const [endDateSearch, setEndDateSearch] = useState<any>(moment().endOf('month'));
  const [openDatePicker, setOpenDatePicker] = useState<boolean>(false);

  const onCloseDatePicker = () => {
    if (setStartDate && setEndDate) {
      setStartDate(new Date(startDateSearch));
      setEndDate(new Date(endDateSearch));
    }
    setOpenDatePicker(false);
  };

  const onApplyDate = () => {
    setStartDateSearch(startDate);
    setEndDateSearch(endDate);
    setOpenDatePicker(false);

    const hasTranslateIndex: any = [];
    const hasMaskIndex: any = [];
    const headerIds = header.map((h, idx) => {
      if (h.type === 'translate') {
        hasTranslateIndex.push(idx);
      }
      if (h.mask) {
        hasMaskIndex.push({ idx, mask: h.mask });
      }
      return h.id;
    });
    const headerSubIds = header.reduce((acc: any, h) => {
      if (h.subId) {
        acc.push(h.subId);
      }
      return acc;
    }, []);

    var teste = _.filter(tableData, (data: any) => {
      return (
        _.at(data, headerIds).find((val, idx) =>
          hasTranslateIndex.includes(idx)
            ? tableStatusColor(val)
                .translate.toString()
                .toLowerCase()
                .includes(filterName.toLocaleLowerCase()) ||
              val?.toString().toLowerCase().includes(filterName.toLocaleLowerCase())
            : hasMaskIndex.find((m: any) => m.idx === idx)
              ? tableMasks(hasMaskIndex.find((m: any) => m.idx === idx).mask, val)
                  .toString()
                  .toLowerCase()
                  .includes(filterName.toLocaleLowerCase()) ||
                val?.toString().toLowerCase().includes(filterName.toLocaleLowerCase())
              : val?.toString().toLowerCase().includes(filterName.toLocaleLowerCase())
        ) ||
        (headerSubIds.length > 0 &&
          _.at(data, headerSubIds).find((val: any) =>
            val?.toString().toLowerCase().includes(filterName.toLocaleLowerCase())
          ))
      );
    });

    if (selectedOption.length !== 0 && selectedOption !== '' && selectedOption !== 'Todas') {
      teste = _.filter(teste, (data: any) => {
        return data.storeName === selectedOption;
      });
    }

    const filteredByDate = teste.filter((data: any) => {
      if (startDate && endDate) {
        const dataDate = new Date(data.createdAt);
        return dataDate >= startDate && dataDate <= endDate;
      }
      return true;
    });

    setFilteredData(filteredByDate);
  };

  useEffect(() => {
    if (filterName) {
      onFilter(filterName);
    } else {
      setFilteredData(tableData);
    }
    setSelected([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  const onSort = (id: string) => {
    const isAsc = orderBy === id && order === 'asc';
    if (id !== '') {
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(id);
    }
  };

  const onSelectRow = (id: string) => {
    if (onSelectRowFunction) {
      onSelectRowFunction(id);
    }

    const selectedIndex = selected.indexOf(id);

    let newSelected: string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const onSelectAllRows = (checked: boolean, newSelecteds: string[]) => {
    if (checked) {
      if (onSelectAllRowFunction) {
        onSelectAllRowFunction(newSelecteds);
      }
      setSelected(newSelecteds);
      return;
    }
    if (onSelectAllRowFunction) {
      onSelectAllRowFunction([]);
    }
    setSelected([]);
  };

  const onChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const onChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    return () => {
      onFilterName.cancel();
    };
  });

  const onFilter = async (value: any) => {
    setFilterName(value);
    const hasTranslateIndex: any = [];
    const hasMaskIndex: any = [];
    const headerIds = header.map((h, idx) => {
      if (h.type === 'translate') {
        hasTranslateIndex.push(idx);
      }
      if (h.mask) {
        hasMaskIndex.push({ idx, mask: h.mask });
      }
      return h.id;
    });
    const headerSubIds = header.reduce((acc: any, h) => {
      if (h.subId) {
        acc.push(h.subId);
      }
      return acc;
    }, []);

    const teste = _.filter(tableData, (data: any) => {
      return (
        _.at(data, headerIds).find((val, idx) =>
          hasTranslateIndex.includes(idx)
            ? tableStatusColor(val)
                .translate.toString()
                .toLowerCase()
                .includes(value.toLocaleLowerCase()) ||
              val?.toString().toLowerCase().includes(value.toLocaleLowerCase())
            : hasMaskIndex.find((m: any) => m.idx === idx)
              ? tableMasks(hasMaskIndex.find((m: any) => m.idx === idx).mask, val)
                  .toString()
                  .toLowerCase()
                  .includes(value.toLocaleLowerCase()) ||
                val?.toString().toLowerCase().includes(value.toLocaleLowerCase())
              : val?.toString().toLowerCase().includes(value.toLocaleLowerCase())
        ) ||
        (headerSubIds.length > 0 &&
          _.at(data, headerSubIds).find((val: any) =>
            val?.toString().toLowerCase().includes(value.toLocaleLowerCase())
          ))
      );
    });
    setFilteredData(teste);
  };

  const onSelect = (opt: any) => {
    setSelectedOption(opt);
    const hasTranslateIndex: any = [];
    const hasMaskIndex: any = [];
    const headerIds = header.map((h, idx) => {
      if (h.type === 'translate') {
        hasTranslateIndex.push(idx);
      }
      if (h.mask) {
        hasMaskIndex.push({ idx, mask: h.mask });
      }
      return h.id;
    });
    const headerSubIds = header.reduce((acc: any, h) => {
      if (h.subId) {
        acc.push(h.subId);
      }
      return acc;
    }, []);

    let teste = _.filter(tableData, (data: any) => {
      return (
        _.at(data, headerIds).find((val, idx) =>
          hasTranslateIndex.includes(idx)
            ? tableStatusColor(val)
                .translate.toString()
                .toLowerCase()
                .includes(filterName.toLocaleLowerCase()) ||
              val?.toString().toLowerCase().includes(filterName.toLocaleLowerCase())
            : hasMaskIndex.find((m: any) => m.idx === idx)
              ? tableMasks(hasMaskIndex.find((m: any) => m.idx === idx).mask, val)
                  .toString()
                  .toLowerCase()
                  .includes(filterName.toLocaleLowerCase()) ||
                val?.toString().toLowerCase().includes(filterName.toLocaleLowerCase())
              : val?.toString().toLowerCase().includes(filterName.toLocaleLowerCase())
        ) ||
        (headerSubIds.length > 0 &&
          _.at(data, headerSubIds).find((val: any) =>
            val?.toString().toLowerCase().includes(filterName.toLocaleLowerCase())
          ))
      );
    });
    if (opt !== '' && opt !== 'Todas') {
      teste = _.filter(teste, (data: any) => {
        return data.storeName === opt;
      });
    }
    setFilteredData(teste);
  };

  const onFilterName = useMemo(() => {
    const onFilterDebounced = async (e: any) => {
      setLoadingSearch(true);
      await new Promise((r) => setTimeout(r, 10));
      setFilterName(e.target.value);
      const hasTranslateIndex: any = [];
      const hasMaskIndex: any = [];
      const headerIds = header.map((h, idx) => {
        if (h.type === 'translate') {
          hasTranslateIndex.push(idx);
        }
        if (h.mask) {
          hasMaskIndex.push({ idx, mask: h.mask });
        }
        return h.id;
      });
      const headerSubIds = header.reduce((acc: any, h) => {
        if (h.subId) {
          acc.push(h.subId);
        }
        return acc;
      }, []);

      let teste = _.filter(tableData, (data: any) => {
        return (
          _.at(data, headerIds).find((val, idx) =>
            hasTranslateIndex.includes(idx)
              ? tableStatusColor(val)
                  .translate.toString()
                  .toLowerCase()
                  .includes(e.target.value.toLocaleLowerCase()) ||
                val?.toString().toLowerCase().includes(e.target.value.toLocaleLowerCase())
              : hasMaskIndex.find((m: any) => m.idx === idx)
                ? tableMasks(hasMaskIndex.find((m: any) => m.idx === idx).mask, val)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLocaleLowerCase()) ||
                  val?.toString().toLowerCase().includes(e.target.value.toLocaleLowerCase())
                : val?.toString().toLowerCase().includes(e.target.value.toLocaleLowerCase())
          ) ||
          (headerSubIds.length > 0 &&
            _.at(data, headerSubIds).find((val: any) =>
              val?.toString().toLowerCase().includes(e.target.value.toLocaleLowerCase())
            ))
        );
      });
      if (selectedOption.length !== 0 && selectedOption !== '' && selectedOption !== 'Todas') {
        teste = _.filter(teste, (data: any) => {
          return data.storeName === selectedOption;
        });
      }
      const filteredByDate = teste.filter((data: any) => {
        if (startDate && endDate) {
          const dataDate = new Date(data.createdAt);
          return dataDate >= startDate && dataDate <= endDate;
        }
        return true;
      });
      setFilteredData(filteredByDate);
      setLoadingSearch(false);
    };
    return _.debounce(onFilterDebounced, 1000);
  }, [header, tableData, selectedOption, startDate, endDate]);

  return {
    order,
    page,
    setPage,
    orderBy,
    rowsPerPage,
    filterName,
    onFilterName,
    filteredData,
    loadingSearch,
    //
    selected,
    selectedOption,
    setSelected,
    onSelectRow,
    onSelectAllRows,
    onSelect,
    //
    onSort,
    onChangePage,
    onChangeRowsPerPage,
    //
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    setOpenDatePicker,
    onCloseDatePicker,
    onApplyDate,
    startDateSearch,
    endDateSearch,
    openDatePicker,
  };
}

// ----------------------------------------------------------------------

export function descendingComparator(a: any, b: any, orderBy: any) {
  var orderByArray = orderBy.toString().split('.');
  var aAux = a;
  var bAux = b;

  orderByArray.forEach((id: any) => {
    aAux = aAux[id] ? aAux[id] : '-';
    bAux = bAux[id] ? bAux[id] : '-';
  });

  if (bAux.toString().toLowerCase() < aAux.toString().toLowerCase()) {
    return -1;
  }
  if (bAux.toString().toLowerCase() > aAux.toString().toLowerCase()) {
    return 1;
  }
  return 0;
}

export function getComparator<Key extends keyof any>(
  order: 'asc' | 'desc',
  orderBy: Key
): (a: { [key in Key]: number | string }, b: { [key in Key]: number | string }) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function emptyRows(page: number, rowsPerPage: number, arrayLength: number) {
  return page > 0 ? Math.max(0, (1 + page) * rowsPerPage - arrayLength) : 0;
}
